import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=0ffe6a72&scoped=true"
var script = {}
import style0 from "./Banner.vue?vue&type=style&index=0&id=0ffe6a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe6a72",
  null
  
)

export default component.exports